import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import UserAuthServices from './user_authService';

export const UserLoginUser = createAsyncThunk(
  'user_auth/UserloginUser',
  async (credentials, thunkAPI) => {
    try {
      const delivered = await UserAuthServices.UserLogin(credentials);

      credentials.navigate('/user_dashboard/home');

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const UserRegistrationUser = createAsyncThunk(
  'user_auth/UserRegistrationUser',
  async (credentials, thunkAPI) => {
    try {
      const delivered = await UserAuthServices.UserRegistration(credentials);

      credentials.navigate('/auth/signin');

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetSingleUserDetails = createAsyncThunk(
  'user_auth/getSingleUserDetails',
  async (_, thunkAPI) => {
    try {
      const delivered = await UserAuthServices.getSingleUserDetails();
      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
